import { Router } from "@angular/router";
import { CreateFailure, CreateManyFailure, CreateManySuccess, CreateSuccess, DeleteFailure, DeleteManyFailure, DeleteManySuccess, EntityActionTypes, LoadAllFailure, LoadFailure, LoadPageFailure, ofEntityType, UpdateFailure, UpdateManyFailure, UpdateManySuccess, UpdateSuccess } from "@briebug/ngrx-auto-entity";
import { Actions, createEffect } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { tap } from "rxjs/operators";

export abstract class AbstractEffects {


    constructor(
        protected _entityClass,
        protected _actions$: Actions,
        protected _messageService: MessageService,
        protected _router: Router,
        protected _translateService: TranslateService,
        protected _entityMessagesKey: string
    ) { }


    loadAllFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.LoadAllFailure),
            tap((action: LoadAllFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: msgs.App.MSG_ERROR_LOAD })
                })
            })
        ),
        { dispatch: false }
    );

    loadPageFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.LoadPageFailure),
            tap((action: LoadPageFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: msgs.App.MSG_ERROR_LOAD })
                })
            })
        ),
        { dispatch: false }
    );

    loadFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.LoadFailure),
            tap((action: LoadFailure<any>) => {
                // if (action.error.status == 404) {
                //     this._router.navigate(['/404']);
                // }
            })
        ),
        { dispatch: false }
    );

    createFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.CreateFailure),
            tap((action: CreateFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action.error.error.error;
                    let error = msgs.App.MSG_ERROR_CREATE;
                    if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_CONFLICT;
                    } else
                        if (message && message == 'Forbidden') {
                            error = msgs.App.MSG_FORBIDDEN;
                        }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                });
            })
        ),
        { dispatch: false }
    );
    createManyFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.CreateManyFailure),
            tap((action: CreateManyFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action.error.error.error;
                    let error = msgs.App.MSG_ERROR_CREATE;
                    if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_CONFLICT;
                    } else
                        if (message && message == 'Forbidden') {
                            error = msgs.App.MSG_FORBIDDEN;
                        }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                })
            })
        ),
        { dispatch: false }
    );
    updateFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.UpdateFailure),
            tap((action: UpdateFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action.error.error.error;
                    let error = msgs.App.MSG_ERROR_UPDATE;
                    if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_CONFLICT;
                    } else if (message && message == 'Invalid Row Version') {
                        error = msgs.App.MSG_ERROR_INVALID_ROW_VERSION;
                    } else
                        if (message && message == 'Forbidden') {
                            error = msgs.App.MSG_FORBIDDEN;
                        }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                })
            })
        ),
        { dispatch: false }
    );

    updateManyFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.UpdateManyFailure),
            tap((action: UpdateManyFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action.error.error.error;
                    let error = msgs.App.MSG_ERROR_UPDATE;
                    if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_CONFLICT;
                    } else if (message && message == 'Invalid Row Version') {
                        error = msgs.App.MSG_ERROR_INVALID_ROW_VERSION;
                    } else
                        if (message && message == 'Forbidden') {
                            error = msgs.App.MSG_FORBIDDEN;
                        }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                })
            })
        ),
        { dispatch: false }
    );
    deleteFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.DeleteFailure),
            tap((action: DeleteFailure<any>) => {

                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action.error.error.error;
                    let error = msgs.App.MSG_ERROR_DELETE;
                    if (message && message == 'Forbidden') {
                        error = msgs.App.MSG_FORBIDDEN;
                    } else if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_DELETE_FK;
                    }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                })
            })
        ),
        { dispatch: false }
    );


    createSucces$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.CreateSuccess),
            tap((action: CreateSuccess<any>) => {
                let criteria = action.criteria;
                if (criteria && criteria.successUrl) {
                    this._router.navigate([criteria.successUrl]);
                }
            })
        ),
        { dispatch: false }
    );

    updateSucces$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.UpdateSuccess),
            tap((action: UpdateSuccess<any>) => {
                let criteria = action.criteria;
                if (criteria && criteria.successUrl) {
                    this._router.navigate([criteria.successUrl]);
                }
            })
        ),
        { dispatch: false }
    );


    createManySucces$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.CreateManySuccess),
            tap((action: CreateManySuccess<any>) => {
                let criteria = action.criteria;
                if (criteria && criteria.successUrl) {
                    this._router.navigate([criteria.successUrl]);
                }
            })
        ),
        { dispatch: false }
    );

    updateManySucces$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.UpdateManySuccess),
            tap((action: UpdateManySuccess<any>) => {
                let criteria = action.criteria;
                if (criteria && criteria.successUrl) {
                    this._router.navigate([criteria.successUrl]);
                }
            })
        ),
        { dispatch: false }
    );

    deleteManyFailure$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.DeleteManyFailure),
            tap((action: DeleteManyFailure<any>) => {
                this._translateService.get(['App']).subscribe(msgs => {
                    let message = action?.error?.error?.error;
                    let error = msgs.App.MSG_ERROR_DELETE;
                    if (message && message == 'Forbidden') {
                        error = msgs.App.MSG_FORBIDDEN;
                    } else if (message && message == 'Conflict') {
                        error = msgs.App.MSG_ERROR_DELETE_FK;
                    }
                    this._messageService.add({ severity: 'error', summary: msgs.App.SUMMARY_ERROR, detail: error })
                })
            })
        ),
        { dispatch: false }
    );
    deleteManySuccess$ = createEffect(
        () => this._actions$.pipe(
            ofEntityType(this._entityClass, EntityActionTypes.DeleteManySuccess),
            tap((action: DeleteManySuccess<any>) => {
                let criteria = action;
                console.log('action', action);

            })
        ),
        { dispatch: false }
    );


}